import { render, staticRenderFns } from "./SupportSign.vue?vue&type=template&id=adfe14da&"
import script from "./SupportSign.vue?vue&type=script&lang=js&"
export * from "./SupportSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports